<template>
    <header id="header">
        <!-- Navbar -->
        <nav data-aos="zoom-out" data-aos-delay="800" class="navbar navbar-expand">
            <div class="container header">
                <!-- Navbar Brand-->
                <a class="navbar-brand" href="/">
                    <img class="navbar-brand-regular" width="65%" src="assets/img/Landing-page-Logo-name.png" alt="brand-logo">
                    <img class="navbar-brand-sticky" width="50%" src="assets/img/Landing-page-Logo-name.png" alt="sticky brand-logo">
                </a>
                <div class="ml-auto"></div>
                <!-- Navbar -->
                <ul class="navbar-nav items">
               
                    <li class="nav-item">
                        <a href="/about" class="nav-link">{{$t('header.aboutus')}}</a>
                    </li>

                    <li class="nav-item">      
                        <a href="/services" class="nav-link">{{$t('header.services')}}</a>
                    </li>

                    <li class="nav-item">
                        <a href="/portfolio-grid" class="nav-link">{{$t('header.ourwork')}}</a>
                    </li>

                    <li class="nav-item">
                        <a href="/contact" class="nav-link">{{$t('header.contactus')}}</a>
                    </li>
                    
                </ul>

         <!-- Navbar Icons -->
                <ul class="navbar-nav icons">
                    <!-- <li class="nav-item">
                        <a href="#" class="nav-link" data-toggle="modal" data-target="#search">
                            <i class="fas fa-search"></i>
                        </a>
                    </li> -->
                    <li class="nav-item social">
                        <a href="https://www.facebook.com/spdevsolution" target="_blank" class="nav-link"><i class="fab fa-facebook-square fa-lg"></i></a>
                    </li>
                    <li class="nav-item social">
                        <a href="#" target="_blank" class="nav-link"><i class="fab fa-line fa-lg"></i></a>
                    </li>

                </ul>

                <!-- icon localeSwitcher -->
                <select v-model="$i18n.locale" @change="changeLanguage">
                      <option value="en">EN</option>
                      <option value="th">TH</option>
                </select>

                <!-- Navbar Toggler -->
                <ul class="navbar-nav toggle">
                    <li class="nav-item">
                        <a href="#" class="nav-link" data-toggle="modal" data-target="#menu">
                            <i class="fas fa-bars toggle-icon m-0"></i>
                        </a>
                    </li>
                </ul>

                <!-- Navbar Action Button -->
                <!-- <ul class="navbar-nav action">
                    <li class="nav-item ml-3">
                        <a href="#" class="btn ml-lg-auto btn-bordered-white"><i class="fas fa-paper-plane contact-icon mr-md-2"></i>Contact Us</a>
                    </li>
                </ul> -->
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    methods:{
        changeLanguage(obj){
            localStorage.setItem('language',obj.target.value)
        }
    }
}
</script>

<style>

</style>